import React from 'react';

import dog from '../assets/images/input/select-dog.png';
import cat from '../assets/images/input/select-cat.png';
import parrot from '../assets/images/input/select-bird.png';
import hamster from '../assets/images/input/select-hamster.png';
import sitter from '../assets/images/sitter/andrew.jpg';

import dogThumbnail from '../assets/images/thumbnail/dog.jpg';
import catThumbnail from '../assets/images/thumbnail/cat.jpg';
import hamsterThumbnail from '../assets/images/thumbnail/hamster.jpg';
import parrotThumbnail from '../assets/images/thumbnail/parrot.jpg';

import flower from '../assets/icon/flower.svg';

import Button from './common/button';
import InputField from './common/inputField';
import ToggleField from './common/toggleField';
import SelectField from './common/selectField';
import SelectMenu from './common/selectMenu';
import SelectThumbnail from './common/selectThumbnail';
import CheckList from './common/checkList';
import TextAreaField from './common/textAreaField';
import TextAreaFilled from './common/textAreaFilled';
import PetProfile from './common/petProfile';
import PetProfileCondensed from './common/petProfileCondensed';
import ServiceReceipt from './common/serviceReceipt';
import ServiceListItem from './common/serviceListItem';
import ServiceQuote from './common/serviceQuote';
import SitterProfile from './common/sitterProfile';
import SideBar from './common/sideBar';
import SignUpProcess from './common/signUpProcess';
import BannerText from './common/bannerText';
import ServiceText from './common/serviceText';
import ThumbnailGallery from './common/thumbnailGallery';
import SectionHeader from './common/sectionHeader';
import ReviewCard from './common/reviewCard';
import PricingCard from './common/pricingCard';

function Elements() {
  return (
    <React.Fragment>
      <div className="section">
        <h1>Call to Actions</h1>
        <div className="cta">
          <Button type="primary" text="Schedule a visit" rounded />
          <Button type="secondary" text="Schedule a visit" rounded />
          <Button type="white" text="Schedule a visit" rounded />
        </div>
        <div className="cta">
          <Button type="primary" text="Schedule a visit" />
          <Button type="secondary" text="Schedule a visit" />
          <Button type="white" text="Schedule a visit" />
        </div>
        <div className="cta">
          <Button type="white" text="Schedule a visit" bordered />
          <Button type="secondary" text="Schedule a visit" bordered />
          <Button type="white" text="Schedule a visit" rounded bordered />
          <Button type="secondary" text="Schedule a visit" rounded bordered />
        </div>
      </div>

      <div className="section">
        <h1>Form Fields</h1>
        <h4>Input Field</h4>
        <InputField
          label="name"
          placeHolder="eg. Israel"
          id="name"
          type="text"
          value="Some sort of test"
          onChange={() => {}}
          error={false}
        />

        <h4>TextArea</h4>
        <TextAreaField
          label="name"
          placeHolder="Placeholder"
          id="name"
          type="text"
          value=""
          onChange={() => {}}
          error={false}
        />

        <h4>Toggle Field</h4>
        <ToggleField
          id="names"
          onSelect={() => {}}
          options={[
            { label: 'Israel', value: 'israel' },
            { label: 'Elisha', value: 'elisha' },
            { label: 'Peter', value: 'peter' },
          ]}
        />

        <h4>Select Field</h4>
        <SelectField
          id="names"
          onSelect={() => {}}
          options={[
            { label: 'Israel', value: 'israel' },
            { label: 'Elisha', value: 'elisha' },
            { label: 'Peter', value: 'peter' },
          ]}
        />

        <h4>Select Menu</h4>
        <SelectMenu
          onSelect={() => {}}
          id="options"
          options={[
            { label: 'Option 1', value: 'Option 1' },
            { label: 'Option 2', value: 'Option 2' },
          ]}
        />

        <h4>Select Thumbnail</h4>
        <SelectThumbnail
          id="names"
          onSelect={() => {}}
          options={[
            { label: 'Dog', value: 'dog', image: dog },
            { label: 'Cat', value: 'cat', image: cat },
            { label: 'Hamster', value: 'hamster', image: hamster },
            { label: 'Parrot', value: 'parrot', image: parrot },
          ]}
        />

        <h4>Check List</h4>
        <CheckList
          id="names"
          onSelect={() => {}}
          options={[
            { value: 'Option 1', selected: true, error: null },
            { value: 'Option 2', selected: false, error: null },
            { value: 'Option 3', selected: false, error: null },
            { value: 'Option 4', selected: false, error: null },
            { value: 'Option 5', selected: false, error: null },
            { value: 'Option 6', selected: false, error: null },
          ]}
        />

        <h4>Textarea filled in</h4>
        <TextAreaFilled
          icon={flower}
          paragraph="We’ll take your pup for a walk and make sure he or she has fresh food
          and water."
          title="Dog Walk"
          price="15"
        />
      </div>
      <div className="section">
        <h1>Marketing</h1>
        <h4>Pet Profile</h4>
        <PetProfile
          image={dog}
          name="Ginger"
          breed="Golden Retriever"
          gender="female"
          spayed={true}
          pound={'50-100'}
          age={'8'}
          favoriteThings={[
            'barking',
            'snuggling',
            'giving kisses',
            'walks',
            'treats',
          ]}
        />
        <h4>Pet Profile Condensed</h4>
        <PetProfileCondensed
          image={dog}
          name="Ginger"
          breed="Golden Retriever"
          gender="female"
          spayed={true}
          pound={'50-100'}
          age={'8'}
          favoriteThings={[
            'barking',
            'snuggling',
            'giving kisses',
            'walks',
            'treats',
          ]}
        />

        <h4>Service Receipt</h4>
        <ServiceReceipt
          image={dog}
          type="Dog walk"
          name="Ginger"
          price="15"
          times={['Morning', 'Evening']}
          recurring={5}
          paymentType={'card'}
        />

        <h4>Service List Item</h4>
        <ServiceListItem
          type="Dog walk"
          times={['Morning', 'Evening']}
          date={'Friday February, 19th'}
          image={dog}
        />

        <h4>Service Quote</h4>
        <ServiceQuote
          text="Please be sure to give her the antibiotics, they’re on the kitchen counter"
          image={dog}
        />
        <h4>Service Quote without image</h4>
        <ServiceQuote
          text="Please be sure to give her the antibiotics, they’re on the kitchen counter"
          image={false}
        />
        <h4>Service Quote with Address</h4>
        <ServiceQuote
          text="123 Fluffypants Lane
          Pawtown, FL 32789
          123-468-8901"
          image={false}
          address={true}
        />

        <h4>Sitter Profile</h4>
        <SitterProfile rating={4.8} name={'Andrew Couldwell'} image={sitter} />

        <h4>Sitter Profile Not Assigned Yet</h4>
        <SitterProfile />
      </div>

      <div className="section">
        <h1>Sidebar</h1>
        <SideBar
          button
          lists={[
            {
              intro: 'profile',
              links: [
                { label: 'Home address', path: '/address' },
                { label: 'Contact info', path: '/contact' },
              ],
            },
            {
              intro: 'payment info',
              links: [
                { label: 'Payment methods', path: '/payment' },
                { label: 'Receipts', path: '/receipt' },
              ],
            },
          ]}
          links={[
            { label: 'My account', path: '/account' },
            { label: 'Support', path: '/support' },
            { label: 'Sign out', path: '/sign-out' },
          ]}
        />
        <h4>Secondary Sidebar</h4>
        <SideBar
          account
          lists={[
            {
              intro: 'services',
              links: [
                { label: 'Scheduled', path: '/schedule' },
                { label: 'Completed', path: '/completed' },
              ],
            },
            {
              intro: 'pets',
              links: [
                { label: 'Ginger', path: '/payment' },
                { label: 'Fluffy', path: '/receipt' },
              ],
            },
          ]}
        />
        <h4>Sign Up Process</h4>
        <SignUpProcess
          links={[
            { label: 'Human Profile', active: true },
            { label: 'Pet profile' },
            { label: 'Pet details' },
            { label: 'Confirm' },
          ]}
        />
      </div>
      <div className="section">
        <h1>Marketing Components</h1>
        <h4>Banner Text</h4>
        <BannerText />
        <h4>Services Text</h4>
        <ServiceText />
        <h4>Thumbnail Gallery</h4>
        <ThumbnailGallery
          images={[
            { label: 'dog', img: dogThumbnail },
            { label: 'cat', img: catThumbnail },
            { label: 'hamster', img: hamsterThumbnail },
            { label: 'parrot', img: parrotThumbnail },
          ]}
        />
        <h4>Section Header</h4>
        <SectionHeader
          heading="Affordable options, tailored to your needs"
          paragraph="All services include live updates including photos and chat, as well as notifications of sitter arrival and departure times."
        />
        <h4>Reviews Card</h4>
        <ReviewCard
          image={dogThumbnail}
          heading={'Lindsay M.'}
          paragraph={
            'Pawtastic is awesome! They are passionate about pets and employ trustworthy, dependable staff. We love them!'
          }
        />
        <h4>Pricing Card</h4>
        <PricingCard
          image={flower}
          type={'Dog walk'}
          paragraph={
            'We’ll take your pup for a 30 minutes walk and make sure he or she has fresh food and water'
          }
          price={15}
        />
      </div>
    </React.Fragment>
  );
}

export default Elements;
